import { dom, library } from "@fortawesome/fontawesome-svg-core";

import { faTwitterSquare } from "@fortawesome/free-brands-svg-icons/faTwitterSquare";
import { faFacebookSquare } from "@fortawesome/free-brands-svg-icons/faFacebookSquare";
import { faStar as faStarOpen } from "@fortawesome/free-regular-svg-icons/faStar";
import { faStar } from "@fortawesome/free-solid-svg-icons/faStar";
import { faShareSquare } from "@fortawesome/free-solid-svg-icons/faShareSquare";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons/faCaretDown";
import { faCaretUp } from "@fortawesome/free-solid-svg-icons/faCaretUp";

library.add(
  faTwitterSquare,
  faFacebookSquare,
  faStarOpen,
  faStar,
  faShareSquare,
  faCaretDown,
  faCaretUp
);
dom.watch();
